import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { CompanyRnwy } from '../models/companyRnwy';

const apiUrl = process.env.REACT_APP_BASIX_API || '';

const getRnwy = async (): Promise<CompanyRnwy> => {
  const { data } = await axios.get(`${apiUrl}settings/Rnwy`);
  return data;
};

// item 614 — the RNWY settings group. Mirrors useCompanyTerms.
const useCompanyRnwy = () => {
  const queryClient = useQueryClient();
  const query = useQuery('companyRnwy', getRnwy);

  const mutation = useMutation(
    (rnwy: CompanyRnwy) => axios.post(`${apiUrl}settings/Rnwy`, rnwy),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('companyRnwy');
      },
    },
  );

  return {
    ...query,
    rnwy: query.data,
    tryUpdate: mutation.mutateAsync,
    isSaving: mutation.isLoading,
  };
};

export default useCompanyRnwy;
